
export function DateTimeHandler(dateTime) {
    if (dateTime) {
        let date = dateTime.split("T")[0];
        let time = dateTime.split("T")[1].split(":");
        time = `${time[0]}:${time[1]}`
        return { date, time };
    } else {
        return dateTime;
    }
}
